<template>
  <Fragment>
    <SectionHeader :companySelect="false">
      <template v-slot:breadcrumbs>
        <h1>
          <router-link to="/admin/users">Admin</router-link>
          <router-link to="/admin/users">{{ $t('meta.users') }}</router-link>
          <router-link :to="`/admin/users/${$route.params.uuid}`"
            >{{ user.first_name }} {{ user.last_name }}</router-link
          >
          <router-link :to="`/admin/users/${$route.params.uuid}`">{{ $t('meta.companies') }}</router-link>
          {{ companyUser && companyUser.company_name }}
        </h1>
      </template>
      <template v-slot:meta>
        <button @click="deleteCompanyUser" class="button button-red button-small button-round">
          {{ $t('admin.user.delete') }}
        </button>
      </template>
    </SectionHeader>
    <div class="body-content cf">
      <div class="entries-wrap">
        <admin-nav></admin-nav>
        <div class="body">
          <LoadingSpinner v-if="loading" full />
          <div v-else>
            <CompanyUser
              :companyUser="companyUser"
              :formTitle="$t('admin.user.editUserRoles')"
              :templateMode="'edit'"
              :user="user"
              @submit="updateCompanyUser"
            />
          </div>
        </div>
      </div>
    </div>
  </Fragment>
</template>
<script>
import { Fragment } from 'vue-fragment'

import CompanyUser from '@/views/admin/users/companies/CompanyUser.vue'

import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import AdminNav from '@/components/admin_nav.vue'

import adminsApi from '@/api/admin'
import companyUsersApi from '@/api/companyUsers'

export default {
  name: 'admin_user_company',
  inject: ['showPopup'],
  components: {
    AdminNav,
    CompanyUser,
    Fragment,
    LoadingSpinner,
    SectionHeader,
  },
  data() {
    return {
      loading: true,
      user: {},
    }
  },
  computed: {
    companyUser() {
      return this.user?.company_users?.find(companyUser => companyUser.company_uuid === this.$route.params.company_uuid)
    },
  },
  methods: {
    async deleteCompanyUser() {
      if (!(await this.showPopup({ content: this.$t('companies.deleteUserConfirmation'), type: 'confirm' }))) return

      const successfulResponse = await companyUsersApi.delete(this.companyUser.uuid)

      if (successfulResponse) {
        await this.$router.push(`/admin/users/${this.$route.params.uuid}`)
      }
    },
    async updateCompanyUser(formData) {
      const params = {
        roles: formData.roles,
      }
      const successfulResponse = await companyUsersApi.update(this.companyUser.uuid, params)

      if (successfulResponse) {
        await this.$router.push(`/admin/users/${this.$route.params.uuid}`)
      }
    },
  },
  async mounted() {
    this.user = await adminsApi.getUser(this.$route.params.uuid)
    this.loading = false
  },
}
</script>
